import strapi, { mapStrapiData } from '../lib/strapi';

import qs from 'qs';

export const getJourneyPageData = async () => {
  try {
    const query = qs.stringify({
      populate: {
        hero_image: true,
        problem_image: true,
        testimonials_list: { populate: '*' }
      }
    });
    const pageRes = await strapi.get(`/our-journey-page?${query}`);
    const projectsRes = await strapi.get('/projects?populate=*&sort=createdAt:desc');

    return {
      content: mapStrapiData(pageRes),
      projects: projectsRes.data.data || [],
    };
  } catch (error) {
    console.error('Error fetching Journey data:', error);
    return null;
  }
};